import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';
import { LINE_ITEM_ANNUAL_PASS_VOUCHER, LINE_ITEM_VOUCHER } from '../../../util/types';
import { itemValueStyles, lineItemStyles } from './BookingBreakdown.styles';

const LineItemVoucherRefundMaybe = ({ transaction, isCustomer }) => {
  const intl = useIntl();

  if (!isCustomer) return null;

  const voucherLineItem = transaction.attributes.lineItems.find(
    (item) => item.code === LINE_ITEM_VOUCHER && item.reversal
  );

  const annualPassVoucherLineItem = transaction.attributes.lineItems.find(
    (item) => item.code === LINE_ITEM_ANNUAL_PASS_VOUCHER && item.reversal
  );

  if (!isCustomer && !(voucherLineItem || annualPassVoucherLineItem)) return null;

  const voucherTotal = voucherLineItem?.lineTotal;
  const formattedTotal = voucherTotal ? formatMoney(intl, voucherTotal) : null;

  const annualPassVoucherTotal = annualPassVoucherLineItem?.lineTotal;
  const annualPassFormattedTotal = annualPassVoucherTotal
    ? formatMoney(intl, annualPassVoucherTotal)
    : null;

  return (
    <>
      {formattedTotal ? (
        <Box sx={lineItemStyles}>
          <Typography sx={{ flex: 1 }} variant="lineItemLabel">
            <FormattedMessage id="BookingBreakdown.voucher.refund" />
          </Typography>
          <Typography sx={itemValueStyles} variant="lineItemLabel">{formattedTotal}</Typography>
        </Box>
      ) : null}
      {annualPassFormattedTotal ? (
        <Box sx={lineItemStyles}>
          <Typography sx={{ flex: 1 }} variant="lineItemLabel">
            <FormattedMessage id="BookingBreakdown.annualPassVoucher.refund" />
          </Typography>
          <Typography sx={itemValueStyles} variant="lineItemLabel">{annualPassFormattedTotal}</Typography>
        </Box>
      ) : null}
    </>
  );
};

export default LineItemVoucherRefundMaybe;
